import { IBriefResource } from "../../briefs";
import { IClassroomResource } from "../../classrooms";
import { createApiMutationHook, IApiMutationFunction } from "../../utils/api";
import { mapRelationalValue, RelationalValue } from "../../utils/filters";
import { ICalendarEventResource, CalendarEventType, RecurrenceFrequency } from "../types";

export type ICalendarEventCreateMutationParameters = {
    classroom: RelationalValue<IClassroomResource>;
    title: string;
    type: CalendarEventType;
    date: string;
    startTime: string;
    endTime?: string;
    brief?: RelationalValue<IBriefResource>;
    location?: string;
    description?: string;
    frequency?: RecurrenceFrequency;
    recurrenceEndDate?: string;
};

export type ICalendarEventCreateMutationResult = ICalendarEventResource;

export const calendarEventCreateMutation: IApiMutationFunction<ICalendarEventCreateMutationParameters> = ({
    classroom,
    title,
    type,
    date,
    startTime,
    endTime,
    brief,
    location,
    description,
    frequency,
    recurrenceEndDate,
}) => {
    return {
        method: "POST",
        url: `/classrooms/${mapRelationalValue(classroom)}/calendar-events`,
        data: {
            title,
            type,
            date,
            startTime,
            endTime,
            location,
            description,
            briefId: mapRelationalValue(brief),
            frequency: frequency?.toUpperCase(),
            recurrenceEndDate,
        },
    };
};

export const useCalendarEventCreateMutation = createApiMutationHook<
    ICalendarEventCreateMutationParameters,
    ICalendarEventCreateMutationResult
>(calendarEventCreateMutation);
